import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';

@Component({
  selector: 'fiko-sph-analiz-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzTabsModule,
    NzCardModule,
    NzIconModule,
    NzGridModule,
    NzBadgeModule,
    NzDividerModule,
    NzSelectModule,
    NzTooltipModule,
    NzDropdownModule,
    NzMenuModule
  ],
  templateUrl: './fiko-sph-analiz-panel.component.html',
  styleUrls: ['./fiko-sph-analiz-panel.component.less']
})
export class FikoSPHAnalizPanelComponent {
  @Input() istatistikler: any = {};
  @Input() sensorVerileri: any[] = [];
  @Output() heatmapSecildi = new EventEmitter<number>();
  @Output() raporOlustur = new EventEmitter<void>();

  // Heatmap types
  heatmapTipleri = [
    { id: 0, ad: 'Hiz', ikon: 'dashboard', aciklama: 'Parcacik hiz dagilimlari' },
    { id: 1, ad: 'Basinc', ikon: 'compress', aciklama: 'Basinc dagilimlari' },
    { id: 2, ad: 'Densitesi', ikon: 'block', aciklama: 'Densitesi dagilimlari' },
    { id: 3, ad: 'Sicaklik', ikon: 'fire', aciklama: 'Sicaklik dagilimlari' },
    { id: 4, ad: 'Vorticity', ikon: 'sync', aciklama: 'Donme hizi dagilimlari' },
    { id: 5, ad: 'Enerji', ikon: 'thunderbolt', aciklama: 'Kinetik enerji dagilimlari' },
    { id: 6, ad: 'Gerilme', ikon: 'pull-request', aciklama: 'Gerilme tensoru' },
    { id: 7, ad: 'Viskozite', ikon: 'filter', aciklama: 'Viskozite dagilimlari' }
  ];

  seciliHeatmap: number = 0;

  // Export formats
  dosyaFormatlari = [
    { deger: 'html', etiket: 'HTML Rapor', ikon: 'file-text' },
    { deger: 'json', etiket: 'JSON Veri', ikon: 'file-code' },
    { deger: 'csv', etiket: 'CSV Tablosu', ikon: 'table' },
    { deger: 'pdf', etiket: 'PDF Belgesi', ikon: 'file-pdf' }
  ];

  // Mock sensor data for display
  ornekSensorler = [
    { id: '1', ad: 'Giris Basinci', tip: 'basinc', deger: 101325, birim: 'Pa' },
    { id: '2', ad: 'Giris Hizi', tip: 'hiz', deger: 1.5, birim: 'm/s' },
    { id: '3', ad: 'Sicaklik', tip: 'sicaklik', deger: 680, birim: '°C' },
    { id: '4', ad: 'Dolum Sensoru', tip: 'dolum', deger: 45, birim: '%' }
  ];

  constructor() {}

  heatmapSec(tip: number): void {
    this.seciliHeatmap = tip;
    this.heatmapSecildi.emit(tip);
  }

  raporOlusturTikla(): void {
    this.raporOlustur.emit();
  }

  degerFormatla(deger: number, birim: string): string {
    if (typeof deger !== 'number') return '-';

    if (birim === 'Pa') {
      return (deger / 1000).toFixed(1) + ' kPa';
    } else if (birim === '%') {
      return deger.toFixed(1) + '%';
    } else {
      return deger.toFixed(2) + ' ' + birim;
    }
  }

  istatistikDegeriAl(anahtar: string): any {
    return this.istatistikler?.[anahtar] || 0;
  }

  formatSayi(deger: number, ondalik: number = 2): string {
    if (typeof deger !== 'number') return '-';
    return deger.toFixed(ondalik);
  }

  getSensorRengi(tip: string): string {
    const renkler: any = {
      'basinc': '#1890ff',
      'hiz': '#4ecca3',
      'sicaklik': '#ff4d4f',
      'dolum': '#ffa500',
      'densitesi': '#722ed1'
    };
    return renkler[tip] || '#a0a0a0';
  }

  dosyaFormatSec(format: string): void {
    console.log('Dosya formati secildi:', format);
    this.raporOlusturTikla();
  }
}
